import SectionHeading from "@/pages/home/components/SectionHeading";
import { streamerStyles } from "@/mocks/content";

export default function StreamerStyles() {
  return (
    <section id="streamers" className="w-full bg-background-50 py-16 md:py-24 px-4 md:px-8">
      <div className="max-w-7xl mx-auto">
        <SectionHeading
          eyebrow="热门主播风格图谱"
          title="六种常见主播风格，对号入座再关注"
          desc="主播的风格直接决定观看体验。下面按常见形态归纳出六种类型，每种都标注了适合人群与互动节奏，方便你按偏好挑选。"
        />

        <div className="mt-10 md:mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {streamerStyles.map((s) => (
            <article
              key={s.id}
              className="group rounded-lg overflow-hidden bg-background-100 border border-background-200/80 hover:border-primary-300 transition-colors"
            >
              <div className="relative w-full h-52 md:h-60 overflow-hidden">
                <img
                  src={s.image}
                  alt={`${s.name}主播风格封面示意`}
                  title={`快猫主播风格 ${s.name}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
                <span className="absolute top-3 left-3 text-[11px] font-medium text-background-50 bg-primary-500/90 px-2.5 py-1 rounded-full backdrop-blur-sm">
                  {s.tag}
                </span>
                <h3 className="absolute bottom-3 left-4 right-4 font-heading font-bold text-background-50 text-lg">
                  {s.name}
                </h3>
              </div>
              <div className="p-5">
                <p className="text-sm text-foreground-700 leading-relaxed">{s.signature}</p>
                <dl className="mt-4 space-y-2 text-sm">
                  <div className="flex items-start gap-2">
                    <dt className="text-foreground-400 shrink-0 flex items-center gap-1">
                      <i className="ri-user-heart-line"></i>适合
                    </dt>
                    <dd className="text-foreground-700">{s.bestFor}</dd>
                  </div>
                  <div className="flex items-start gap-2">
                    <dt className="text-foreground-400 shrink-0 flex items-center gap-1">
                      <i className="ri-pulse-line"></i>节奏
                    </dt>
                    <dd className="text-secondary-700 font-medium">{s.rhythm}</dd>
                  </div>
                </dl>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}